import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import {
    CraftDetailsDto,
    CraftService,
    FlyFreelyError,
    FlyFreelyLoggingService,
    UpdateNotesCommand,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDialoguesService } from '@flyfreely-portal-ui/common-dialogues';

@Component({
    selector: 'notes-edit',
    templateUrl: './notes-edit.component.html',
    styleUrls: ['./notes-edit.component.scss']
})
export class NotesEditComponent implements OnInit, OnDestroy {
    @Input() rpa: CraftDetailsDto;

    rpaNotesForm: FormGroup;
    private workTracker = new WorkTracker();
    working = false;
    private ngUnsubscribe$ = new Subject<void>();

    @Output() cancelled = new EventEmitter();

    constructor(
        private commonDialoguesService: CommonDialoguesService,
        private craftService: CraftService,
        private logging: FlyFreelyLoggingService
    ) {
        this.workTracker.observable
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(working => (this.working = working));
    }

    ngOnInit(): void {
        this.rpaNotesForm = new FormGroup({
            notes: new FormControl(this.rpa.notes)
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    confirmCancel() {
        this.commonDialoguesService
            .showConfirmationDialogue(
                'Confirm Cancel',
                `You have unsaved changes, are you sure you want to cancel?`,
                'Yes',
                () => Promise.resolve()
            )
            .then(() => this.cancelEdit());
    }

    cancel() {
        if (this.rpaNotesForm.dirty) {
            this.confirmCancel();
        } else {
            this.cancelEdit();
        }
    }

    cancelEdit() {
        this.cancelled.emit(null);
    }

    saveNotes() {
        if (this.rpaNotesForm.invalid) {
            return;
        }
        const values = this.rpaNotesForm.value;
        const payload = {
            id: this.rpa.id,
            notes: values.notes
        } as UpdateNotesCommand;
        if (this.rpa.id) {
            this.craftService
                .updateCraftNotes(this.rpa.id, payload)
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe({
                    next: () => {
                        this.logging.success('Update RPA Notes Successfully');
                        this.rpaNotesForm.markAsPristine();
                        this.cancel();
                    },
                    error: (error: FlyFreelyError) =>
                        this.logging.error(
                            error,
                            `Error while update RPA Notes: ${error.message}`
                        )
                })
                .add(this.workTracker.createTracker());
        }
    }
}
